import React from 'react'
import { FiPlusCircle } from 'react-icons/fi'
import { icosIndicators } from '../app/Paths'

export const CardSummary = ({ title, value, icon, onClick, searchType }) => {

    // const handleOpen = () => {
    //     if (onOpenModal && searchType) {
    //         onOpenModal(searchType); // pasas el tipo de consulta
    //     }
    // };

    // <br />
    return (
        <div className="card" style={{ cursor: 'pointer' }} 
        onClick={onClick}
        >
            <div className="card-body">
                <div className="row mb-2">
                    <div className="col mt-0">
                        <h4 className="fw-bold text-black">{title}</h4>
                    </div>
                    <div className="col-auto">
                        <div className="stat text-primary">
                            <img src={icosIndicators[icon]} className="img-fluid" width={28} alt="tool" />
                        </div>
                    </div>
                </div>
                <div className='text-center'>
                    <h1 className="mt-1 mb-1 text-muted fw-bold">
                        {
                            (searchType != 9) ? <>{value}</> : <>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value)}</>
                        }
                    </h1>
                </div>
            </div>
        </div>
    )
}
